import React from 'react';
import SmallCard from 'components/SmallCard';

import AdobeIcon from '@react/react-spectrum/Icon/AdobeLogo';
import AutomotiveIcon from '@spectrum-icons/workflow/Car';
import CpgIcon from '@spectrum-icons/workflow/Shop';
import DefaultIcon from '@spectrum-icons/workflow/Box';
import EnablementIcon from '@spectrum-icons/workflow/Education';
import FsiIcon from '@spectrum-icons/workflow/Building';
import HealthcareIcon from '@spectrum-icons/workflow/Heart';
import HighTechIcon from '@spectrum-icons/workflow/DeviceDesktop';
import MediaIcon from '@spectrum-icons/workflow/VideoOutline';
import MobileIcon from '@spectrum-icons/workflow/DevicePhone';
import RetailIcon from '@spectrum-icons/workflow/ShoppingCart';
import TelcoIcon from '@spectrum-icons/workflow/SocialNetwork';
import TravelIcon from '@spectrum-icons/workflow/Airplane';

const ICON_MAPPING = {
  adobe: AdobeIcon,
  automotive: AutomotiveIcon,
  cpg: CpgIcon,
  enablement: EnablementIcon,
  fsi: FsiIcon,
  healthcare: HealthcareIcon,
  highTech: HighTechIcon,
  media: MediaIcon,
  mobile: MobileIcon,
  retail: RetailIcon,
  telco: TelcoIcon,
  travel: TravelIcon
};

export function PresetCard({ preset, selected, disabled, onClick }) {
  const Icon = ICON_MAPPING[preset.icon] || DefaultIcon;

  return (
    <SmallCard
      icon={Icon}
      key={preset.name}
      title={preset.title}
      link={preset.link}
      selected={selected}
      disabled={disabled}
      onClick={onClick}
    />
  );
}
